export default class weChatAuth {
  constructor (config) {
    const defaultConfig = {
      appid: '',
      responseType: 'code',
      scope: 'snsapi_base '
    }
    this.config = Object.assign(defaultConfig, config)
  }

  openAuthPage () {
    let url = location.href.split('?')[0]
    // 构建后参数前面自动带了斜杆, 所以去掉最后的斜杆
    url = url.replace(/\/$/g, '')
    url = url + '?' + location.search
    const proxyUrl = 'http://newvip.ijinshan.com/vip_login_proxy.html?origin=' + url

    const redirectUri = encodeURIComponent(proxyUrl)
    const authPageBaseUri = '//open.weixin.qq.com/connect/qrconnect'
    const authParams = `?appid=${this.config.appid}&redirect_uri=${redirectUri}&response_type=${this.config.responseType}&scope=${this.config.scope}#wechat_redirect`
    window.location.href = authPageBaseUri + authParams
  }
}
